(function () {
    const iframes = document.querySelectorAll('iframe.instagram-media');

    iframes.forEach(iframe => {
        const adjust = () => {
            iframe.style.minWidth = '';
            iframe.style.width = '100%';

            // MOBILE FIX
            if (window.innerWidth <= 480) {
                iframe.style.height = '600px';
            } else {
                iframe.style.height = '';
            }
        };

        adjust();

        const observer = new MutationObserver(() => adjust());

        observer.observe(iframe, {
            attributes: true,
            attributeFilter: ['style']
        });

        window.addEventListener('resize', adjust);
    });
})();